// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { useSelector } from "react-redux";
import * as R from "ramda";

import { FilterItem as StyledFilterItem, CloseButton } from "../styles";
import ChecklistName from "src/components/Manage/Builder/Checklist/Name/PrincipalChecklist";
import { processColumnNames } from "src/constants/display";
import * as colors from "src/styles/constants/colors";
import { getCanEditReportFilters } from "src/reducers/combinedSelectors";
import Icon from "src/icons";

type Props = {
  column: string,
  clearSort: Function,
};

const SortItem = ({ column, clearSort }: Props) => {
  // Check if the column is checklist field if it is not display built in column names
  // else resolve checklist field names
  const columnName = R.head(column.split(":") || "");

  const isFilteringAllowed = useSelector((state) =>
    getCanEditReportFilters(state),
  );

  if (isNaN(columnName)) {
    return (
      <StyledFilterItem isFilteringAllowed={isFilteringAllowed}>
        <span>
          {processColumnNames[columnName]}
          {i18n.t(k._)}
        </span>
        <strong>
          {R.includes("asc", column)
            ? i18n.t(k.ASCENDING)
            : i18n.t(k.DESCENDING)}
        </strong>
        {isFilteringAllowed && (
          <CloseButton onClick={() => clearSort(column)}>
            <Icon type="close" color={colors.active} />
          </CloseButton>
        )}
      </StyledFilterItem>
    );
  }

  return (
    <StyledFilterItem isFilteringAllowed={isFilteringAllowed}>
      <span>
        <ChecklistName fieldId={columnName} />
        {i18n.t(k._)}
      </span>
      <strong>
        {R.includes("asc", column) ? i18n.t(k.ASCENDING) : i18n.t(k.DESCENDING)}
      </strong>
      {isFilteringAllowed && (
        <CloseButton onClick={() => clearSort(column)}>
          <Icon type="close" color={colors.active} />
        </CloseButton>
      )}
    </StyledFilterItem>
  );
};

export default SortItem;
